import React, {useState} from 'react'
import {Spinner} from '../loader-spinner'
import {CatalogSectionContainer} from '../ui/command-center-layout'
import {Header, Button, ParagraphText, withModal} from '@thryvlabs/maverick'
import {
  // commandCenterIcon,
  // marketingCenterIcon,
  // reportingCenterIcon,
  // workforceCenterIcon,
  commandCenterIconV1,
  workforceCenterIconv1,
  marketingCenterIconv1,
  businessCenterIconv1,
  reportingCenterIconv1,
  ccCouponIcon,
  thryvGrowthPlatformIcon,
  // businessCenterIcon,
  ccDiscountIcon,
  keapMaxIcon,
} from '../../assets'
import {CouponModal} from './coupon-modal'
import {ConfirmationModal} from './confirmation-modal'
import {BillingNoticeModal} from '../billing-notice-modal'
import {CartItem} from './cart-item'
import {UpdateAddressModal} from '../update-address-modal'
import {COUNTRIES, CC_CURRENCIES} from '../../utils/constants'
import {
  BC_PLANS,
  MC_PLANS,
  SOCIAL_ADS_BNI_PLAN_CODES,
  KEAP_FAMILY_CODES,
} from '../../utils/constants'
import {formatPrice} from '../../utils/currency-format'
import {CancelOrderModal} from '../cancel-order-modal'
import {useWindowDimensions} from '../../utils/use-window-dimensions'
import {PlanDiscountsModal} from './plan-discounts-modal'
import {useAuthClient} from '../../utils/use-auth-client'
import {useAsync} from '../../utils/use-async'
import {useLocation} from 'react-router'
import {AccountFailedModalComponent} from '../account-failed-modal'
import {resolveApplicableFees} from '../../utils/feeUtils'
import {useUserRoles} from '../../utils/use-user-roles'

const DEFAULT_CART_ITEMS = [
  {
    name: 'Thryv Growth Platform',
    img: thryvGrowthPlatformIcon,
  },
  {
    name: 'Business Center',
    img: businessCenterIconv1,
  },
  {
    name: 'Marketing Center',
    img: marketingCenterIconv1,
  },
  {
    name: 'Reporting Center',
    img: reportingCenterIconv1,
  },
  {
    name: 'Keap Max',
    img: keapMaxIcon,
  },
]

// const OLD_MC_CENTERS = {
//   'Starter (Monthly)': 'Marketing Center',
//   'Starter (Annual)': 'Marketing Center',
//   'Signature (Monthly)': 'Marketing Center',
//   'Signature (Annual)': 'Marketing Center',
//   'Premier (Monthly)': 'Marketing Center',
//   'Premier (Annual)': 'Marketing Center',
// }

const APPS_IN_CENTERS = [
  'Thryv Leads',
  'SEO Non-Guaranteed',
  'SEO Money Back Guarantee',
  // 'SEO',
]

const CENTER_CODES = ['bc', 'cc', 'mc']

const RenderItems = ({
  items,
  filterFunc = () => true,
  isCenter = false,
  selectedCentersAndApps,
  isNewTLMCAccessible,
  handleRemoveItem,
  prodType,
  defaultCentersAndApps,
  selectedCountry,
}) => {
  return items.filter(filterFunc).map(({id, code, name, img, ...content}) => {
    // addon-5-keap-addons must display as "Keap Add-Ons" (not "Thryv Add-Ons")
    const displayName =
      code === 'addon-5-keap-addons' || code === 'addon-5-keap-addons-annual'
        ? 'Keap Add-Ons'
        : name
    isCenter =
      APPS_IN_CENTERS.includes(name) ||
      [
        'tl-mc-5-thryv-m2m',
        'tl-tax-5-thryv-m2m',
        'tl-5-thryv-m2m',
        // FULSAS-12281: AI Visibility Boost is a stackable App, not a Center,
        // but needs the same OPTIONS-panel nested-entitlement rendering as
        // Centers get (Social Posts / Blog Creation opt-in/opt-out toggles).
        'addon-5-visibilityboost',
      ].includes(code)
    console.log('isCenter :: ', isCenter)
    const isListingsApp = code === 'app-listings'
    const isBCorMCInCart = selectedCentersAndApps?.centers.some(
      ({code}) => BC_PLANS.includes(code) || MC_PLANS.includes(code),
    )

    const isNewSEO = selectedCentersAndApps?.apps.find(
      ({code}) => code === 'seobase-5-thryv-m2m',
    )
    const TL_CODES = [
      'tl-mc-5-thryv-m2m',
      'tl-tax-5-thryv-m2m',
      'tl-5-thryv-m2m',
    ]
    let isTLAdded
    if (isNewTLMCAccessible) {
      isTLAdded =
        selectedCentersAndApps?.centers.find(item =>
          TL_CODES.includes(item.code),
        ) ||
        selectedCentersAndApps?.apps.find(item => TL_CODES.includes(item.code))
    }
    const isMCPEditor = code === 'addon-5-mktproeditor'
    const isBCUnlimitedInOrder = selectedCentersAndApps?.centers?.some(
      ({code}) => code === 'bc_unlm-5-thryv-m2m',
    )
    return (
      <CartItem
        key={id || code}
        title={displayName}
        img={img}
        content={{id, code, name, img, ...content}}
        isCenter={isCenter}
        selectedCentersAndApps={selectedCentersAndApps}
        crossedOut={
          (['seombg-5-thryv-m2m', 'seo-5-thryv-m2m'].includes(code) &&
            isNewSEO) ||
          (['Expanded Growth Package', 'Starter Growth Package'].includes(
            name,
          ) &&
            isTLAdded) ||
          (isMCPEditor && isBCUnlimitedInOrder)
            ? true
            : isListingsApp && isBCorMCInCart
        }
        handleRemoveItem={handleRemoveItem}
        prodType={prodType}
        defaultCentersAndApps={defaultCentersAndApps}
        selectedCountry={selectedCountry}
      />
    )
  })
}

function CouponButton({showModal}) {
  return (
    <div
      data-testid="coupon-button"
      onClick={showModal}
      style={{
        border: '1px solid #057AFF',
        borderRadius: '4px',
        padding: '10px 8px',
        cursor: 'pointer',
        backgroundColor: '#057AFF1A',
      }}
    >
      <img
        height="10.5px"
        width="15.88px"
        alt="coupon icon"
        src={ccCouponIcon}
      />
    </div>
  )
}

function OpenModalButton({showModal, variant = 'primary', text}) {
  return (
    <Button variant={variant} buttonType="outlined" onClick={showModal}>
      {text}
    </Button>
  )
}

function PlanDiscountsButton({showModal}) {
  return (
    <div
      data-testid="discount-button"
      onClick={showModal}
      style={{
        border: '1px solid var(--utility-alert-warning, #FAC02B)',
        background:
          'linear-gradient(0deg, rgba(250, 192, 43, 0.10) 0%, rgba(250, 192, 43, 0.10) 100%), #FFF',
        borderRadius: '4px',
        padding: '8px 8px',
        cursor: 'pointer',
        marginLeft: '10px',
      }}
    >
      <img
        height="10.5px"
        width="15.88px"
        alt="coupon icon"
        src={ccDiscountIcon}
      />
    </div>
  )
}

function OrderSummary({
  nextStep,
  selectedCentersAndApps,
  isWebsiteValid,
  hasPaidDesignFee,
  code,
  setCode,
  handleStartOver,
  oneTimeFees,
  selectedCountry,
  isUpgrade,
  setAccountInfo,
  accountInfo,
  order,
  totalPrice,
  defaultCentersAndApps,
  expiredCentersAndApps,
  all5PlanPrices,
  monthlyTotal,
  orderData5CU,
  setOrderData5CU,
  captureOrder5NewUpgrade,
  isNewTLMCAccessible,
  keapAccount,
  setKeapAccount,
  keapID,
  setKeapID,
  hasKeapAccountAbility,
  setHasKeapAccountAbility,
  setDiscountType,
  discountType,
  isBillingNoticeDisplayed,
  setIsBillingNoticeDisplayed,
  isWebsiteDesignFeeWaived,
  handleRemoveItem,
  thryvId,
  ccId,
  setCCAccountInfo,
  onboardingFeeRequired,
  includeOnboarding,
  upgradePaymentPreview,
}) {
  const {roles} = useUserRoles()
  const isPartnerOpsUser = roles.includes('PartnerOps')

  const clientGroup = keapAccount ? 'keap' : ''
  const [isAddressUpdated, setIsAddressUpdated] = useState(false)

  // In upgrade mode the address is managed via Account Management — skip the popup
  // by auto-seeding saveBillingAddress from the existing accountInfo on first render.
  const isUpgradePath = isUpgrade
  React.useEffect(() => {
    if (!isUpgradePath || isAddressUpdated || !accountInfo) return
    const ba = accountInfo.billingAddress || {}
    saveBillingAddress({
      firstName: accountInfo.firstName || accountInfo.recurlyFirst || '',
      lastName: accountInfo.lastName || accountInfo.recurlyLast || '',
      company: accountInfo.company || accountInfo.recurlyCompany || '',
      street1: ba.street1 || '',
      city: ba.city || '',
      region: ba.region || ba.state || '',
      postalCode: ba.postalCode || ba.zipCode || '',
      phone: ba.phone || accountInfo.phone || '',
      mobile: accountInfo.mobile || ba.phone || '',
      abn: accountInfo.abn || '',
    })
    setIsAddressUpdated(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpgradePath, accountInfo])

  const [showAccountFailedModal, setShowAccountFailedModal] = useState(false)
  const [accountFailedErrorMessage, setAccountFailedErrorMessage] =
    useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const {width: windowWidth} = useWindowDimensions()
  const {pathname, state: locationState} = useLocation()
  const isNewOrder = pathname === '/order/new'
  const isFromAccountSetup = isNewOrder && locationState?.currentStep === 5
  const client = useAuthClient()
  const {run} = useAsync({
    status: 'pending',
  })
  const CouponButtonWithModal = withModal(CouponButton, CouponModal)
  const StartOverButtonWithModal = withModal(OpenModalButton, ConfirmationModal)
  const PlanDiscountsButtonWithModal = withModal(
    PlanDiscountsButton,
    PlanDiscountsModal,
  )

  const isCanAusNz = ['CA', 'AU', 'NZ'].includes(selectedCountry)
  const isAus = selectedCountry === 'AU'
  const isNZ = selectedCountry === 'NZ'
  const TL_CODES = ['tl-mc-5-thryv-m2m', 'tl-tax-5-thryv-m2m', 'tl-5-thryv-m2m']
  const isTLInCart =
    selectedCentersAndApps?.centers.some(({code}) => TL_CODES.includes(code)) ||
    selectedCentersAndApps?.apps?.some(({code}) => TL_CODES.includes(code))
  let homeServicesAdded = selectedCentersAndApps?.apps?.find(({code}) =>
    [
      'maxhvac-5-thryv-m2m',
      'maxroof-5-thryv-m2m',
      'maxelect-5-thryv-m2m',
      'maxplumb-5-thryv-m2m',
    ].includes(code),
  )
  let isNewHomeServices = false
  if (homeServicesAdded) {
    if (!(homeServicesAdded?.alreadyIncluded === true)) isNewHomeServices = true
  }
  if (isNewHomeServices) {
    oneTimeFees = oneTimeFees.filter(({code}) => {
      if (code === 'thryvprfee') {
        return false
      }
      if (code === 'thryvdesg2') {
        return false
      }
      return true
    })
  }
  if (onboardingFeeRequired?.value === 'No') {
    oneTimeFees = oneTimeFees.filter(
      ({code}) => code !== 'keap-ignite-thryvprfee' && code !== 'thryvprfee',
    )
  }
  // FULSAS-12295: don't waive the Onboarding Fee when a Keap product is in
  // the cart — for a Keap add, thryvprfee is a new charge, not a duplicate
  // of the Starter onboarding opt-in (mirrors the isKeapInCart nuance in
  // options.js's oneTimes filter).
  const isKeapInCartForOnboarding = selectedCentersAndApps?.centers?.some(
    ({code}) => KEAP_FAMILY_CODES.includes(code),
  )
  if (includeOnboarding?.value === 'Yes' && !isKeapInCartForOnboarding) {
    oneTimeFees = oneTimeFees.filter(
      ({code}) => code !== 'keap-ignite-thryvprfee' && code !== 'thryvprfee',
    )
  }

  const get24x7SupportFee = () => {
    const {centers} = all5PlanPrices
    const {name, code, currencies, id} = centers.find(
      ({code}) => code === '247support-m2m',
    )
    const amount = currencies.find(
      ({currency}) =>
        currency === CC_CURRENCIES[COUNTRIES[selectedCountry]?.value],
    )?.unitAmount
    const formattedFee = {
      name,
      code,
      quantity: 1,
      amount: amount,
      id,
      entitlements: [],
    }
    return formattedFee
  }

  const handleContinue = async () => {
    if (isNewOrder && thryvId && ccId) {
      try {
        const accountInfo = order?.accountInformation
        const data = {
          thryvId: thryvId,
          ccId: ccId,
          email: accountInfo?.email,
          firstName: accountInfo?.firstName,
          lastName: accountInfo?.lastName,
          company: accountInfo?.company,
          address: {
            street: accountInfo?.address,
            city: accountInfo?.city,
            state: accountInfo?.state,
            zipCode: accountInfo?.postCode,
            country: accountInfo?.country,
          },
        }
        setIsLoading(true)
        const response = await run(
          client('accounts/5/verify-account-created', {data, method: 'PATCH'}),
        )
        setIsLoading(false)
        if (response && response.error) {
          setShowAccountFailedModal(true)
          return
        }
        // The backend verifies (and, if missing, creates) the account in Recurly and
        // returns the authoritative codes — notably the real parent ccId, which it
        // resolves from Recurly even when the request's ccId was wrong. Adopt those so
        // subsequent order calls use the verified account rather than the input codes.
        if (response?.thryvId && response?.ccId && setCCAccountInfo) {
          setCCAccountInfo({thryvId: response.thryvId, ccId: response.ccId})
        }
      } catch (error) {
        setIsLoading(false)
        if (error.status === 422) {
          setAccountFailedErrorMessage(error.message)
        }
        setShowAccountFailedModal(true)
        return
      }
    }
    const defaultCartCodes = [
      ...defaultCentersAndApps.centers,
      ...defaultCentersAndApps.apps,
    ].flatMap(({code, entitlements}) => [
      code,
      ...(entitlements || []).map(e => e.code),
    ])
    const allItemsInCart = [
      ...selectedCentersAndApps.centers,
      ...selectedCentersAndApps.apps,
      ...selectedCentersAndApps.oneTimes,
    ]
    const cartCodes = allItemsInCart
      .filter(({alreadyIncluded}) => !alreadyIncluded)
      .flatMap(({code, entitlements}) => [
        code,
        ...(entitlements || []).map(e => e.code),
      ])
      .filter(code => {
        const centerType =
          CENTER_CODES.some(c => code.includes(c)) && code.split('_')[0]
        return (
          !defaultCartCodes.includes(code) &&
          !defaultCartCodes.some(c => c.includes(centerType))
        )
      })

    const existingCodesOS = [
      ...defaultCentersAndApps.centers.map(c => c.code),
      ...defaultCentersAndApps.apps.map(a => a.code),
    ]
    const applicableFeeCodes = resolveApplicableFees(
      existingCodesOS,
      cartCodes,
      oneTimeFees,
    )
    let applicableOneTimes = oneTimeFees
      .filter(fee => applicableFeeCodes.includes(fee.code))
      .filter(
        ({code}) => !selectedCentersAndApps.oneTimes.some(o => o.code === code),
      )
      .filter(({code}) => !(code === 'thryvdesg2' && isWebsiteDesignFeeWaived))

    let isFeeRequired = false
    let filteredApps
    const isMCorBCInCart = selectedCentersAndApps?.centers.some(
      ({code}) => BC_PLANS.includes(code) || MC_PLANS.includes(code),
    )
    const isBCInCart = selectedCentersAndApps?.centers.some(({code}) =>
      BC_PLANS.includes(code),
    )
    const isMCInCart = selectedCentersAndApps?.centers.some(({code}) =>
      MC_PLANS.includes(code),
    )
    const isBCInDefault = defaultCentersAndApps?.centers.some(({code}) =>
      BC_PLANS.includes(code),
    )
    const isMCInDefault = defaultCentersAndApps?.centers.some(({code}) =>
      MC_PLANS.includes(code),
    )
    const oldMCCenter = defaultCentersAndApps?.centers.find(
      ({code}) => MC_PLANS.includes(code) && code,
    )
    const newMCCenter = selectedCentersAndApps?.centers.find(
      ({code}) => MC_PLANS.includes(code) && code,
    )
    const oldBCCenter = defaultCentersAndApps?.centers.find(
      ({code}) => BC_PLANS.includes(code) && code,
    )
    const newBCCenter = selectedCentersAndApps?.centers.find(
      ({code}) => BC_PLANS.includes(code) && code,
    )
    const is24X7FeeExisting = defaultCentersAndApps?.centers.some(
      ({code}) => '247support-m2m' === code,
    )
    if (is24X7FeeExisting) {
      isFeeRequired = true
    }
    if (isMCorBCInCart) {
      if (isUpgrade) {
        if (isBCInCart && isMCInCart) {
          if (!isBCInDefault && !isMCInDefault) {
            isFeeRequired = false
          } else if (!isBCInDefault && isMCInDefault) {
            if (oldMCCenter?.code !== newMCCenter?.code) {
              isFeeRequired = false
            } else {
              if (is24X7FeeExisting) {
                isFeeRequired = true
              } else {
                isFeeRequired = false
              }
            }
          } else if (isBCInDefault && !isMCInDefault) {
            if (oldBCCenter?.code !== newBCCenter?.code) {
              isFeeRequired = false
            } else {
              if (is24X7FeeExisting) {
                isFeeRequired = true
              } else {
                isFeeRequired = false
              }
            }
          } else {
            if (
              oldMCCenter?.code !== newMCCenter?.code &&
              oldBCCenter?.code !== newBCCenter?.code
            ) {
              isFeeRequired = false
            } else if (
              oldMCCenter?.code === newMCCenter?.code &&
              oldBCCenter?.code !== newBCCenter?.code
            ) {
              if (is24X7FeeExisting) {
                isFeeRequired = true
              } else {
                isFeeRequired = false
              }
            } else if (
              oldMCCenter?.code !== newMCCenter?.code &&
              oldBCCenter?.code === newBCCenter?.code
            ) {
              if (is24X7FeeExisting) {
                isFeeRequired = true
              } else {
                isFeeRequired = false
              }
            }
          }
        } else if (isBCInCart && !isMCInCart) {
          if (isBCInDefault) {
            if (oldBCCenter?.code !== newBCCenter?.code) {
              isFeeRequired = false
            }
          } else {
            isFeeRequired = false
          }
        } else if (isMCInCart && !isBCInCart) {
          if (isMCInDefault) {
            if (oldMCCenter?.code !== newMCCenter?.code) {
              isFeeRequired = false
            }
          } else {
            isFeeRequired = false
          }
        }
      } else {
        isFeeRequired = false
      }
    }
    if (!isFeeRequired) {
      filteredApps = selectedCentersAndApps.centers.filter(
        center => center.code !== '247support-m2m',
      )
    } else {
      const isSupportFeeInCart = selectedCentersAndApps.centers.some(
        ({code}) => code === '247support-m2m',
      )
      if (!isSupportFeeInCart) {
        const supportFee = get24x7SupportFee()
        filteredApps = [...selectedCentersAndApps.centers]
        filteredApps.push(supportFee)
      } else {
        filteredApps = [...selectedCentersAndApps.centers]
      }
    }

    const selectedCentersAndAppsFinal = {
      ...selectedCentersAndApps,
      ...(filteredApps && {centers: filteredApps}),
      oneTimes: [...selectedCentersAndApps.oneTimes, ...applicableOneTimes],
    }
    console.log(
      'order summary - selectedCentersAndAppsFinal',
      selectedCentersAndAppsFinal,
    )
    console.log('order summary - defaultCentersAndApps', defaultCentersAndApps)
    // const orderLines = []
    const orderLines = getOrderLines()
    captureOrder5NewUpgrade(
      'catalog-continue-summary',
      'new-upgrade',
      orderLines,
    )

    nextStep({
      selectedCentersAndApps: selectedCentersAndAppsFinal,
      code,
    })
  }

  const getSassProductQuantity = center => {
    if (center.code === 'seobase-5-thryv-m2m') {
      if (center.tempLineActionCode && center.tempLineActionCode === 'Update') {
        return center.amount
      } else if (
        center.tempLineActionCode &&
        center.tempLineActionCode === 'New'
      ) {
        return center.quantity
      }
    } else {
      return center.quantity ? center.quantity : 1
    }
  }
  const getSassProductPriceAndUamount = (state, center) => {
    if (center.code === 'seobase-5-thryv-m2m') {
      if (center.tempLineActionCode && center.tempLineActionCode === 'Update') {
        const amount = center.quantity
        const quantity = center.amount
        const pUAmount = amount || amount === 0 ? amount : null
        let pUPrice = pUAmount
        if (pUAmount) {
          pUPrice = pUAmount * (quantity ? quantity : 1)
        }
        return state === 'uPrice' ? pUPrice : pUAmount
      } else if (
        center.tempLineActionCode &&
        center.tempLineActionCode === 'New'
      ) {
        const amount = center.amount
        const quantity = center.quantity
        const pUAmount = amount || amount === 0 ? amount : null
        let pUPrice = pUAmount
        if (pUAmount) {
          pUPrice = pUAmount * (quantity ? quantity : 1)
        }
        return state === 'uPrice' ? pUPrice : pUAmount
      }
    } else {
      let pUPrice =
        center.unitAmount || center.unitAmount === 0
          ? center.unitAmount
          : center.amount || center.amount === 0
          ? center.amount
          : null
      if (pUPrice) {
        pUPrice = pUPrice * (center.quantity ? center.quantity : 1)
      }
      return pUPrice
    }
  }

  const getOrderLines = () => {
    const orderLines = []
    const selectedCenters = []
    const selectedApps = []
    const selectedOneTimes = []
    const sCentersAndApps = {...selectedCentersAndApps}
    const dCentersAndApps = {...defaultCentersAndApps}
    if ((sCentersAndApps.centers, dCentersAndApps.centers)) {
      selectedCenters.push(
        ...getAllSelectedDefaultLines(
          'center',
          sCentersAndApps.centers,
          dCentersAndApps.centers,
        ),
      )
    }
    if ((sCentersAndApps.apps, dCentersAndApps.apps)) {
      const tempDApps = []
      const tempSApps = []
      // dCentersAndApps?.apps?.forEach(dLine => {
      //   const foundInArray2 =
      //     dLine.code === 'addon-5-signatures_usage' ||
      //     dLine.code === 'app-websitebuilder'
      //   if (!foundInArray2) tempDApps.push(dLine)
      // })
      // sCentersAndApps?.apps?.forEach(sLine => {
      //   const foundInArray2 =
      //     sLine.code === 'addon-5-signatures_usage' ||
      //     sLine.code === 'app-websitebuilder'
      //   if (!foundInArray2) tempSApps.push(sLine)
      // })

      dCentersAndApps?.apps?.forEach(dLine => {
        tempDApps.push(dLine)
      })
      dCentersAndApps?.apps?.forEach(dLine => {
        if (dLine.addons) {
          dLine.addons.forEach(aLine => {
            const foundInArray2 = tempDApps?.findIndex(
              tLine => tLine.code === aLine.code,
            )
            if (foundInArray2 >= 0) tempDApps.splice(foundInArray2, 1)
          })
        }
      })
      sCentersAndApps?.apps?.forEach(dLine => {
        tempSApps.push(dLine)
      })
      sCentersAndApps?.apps?.forEach(dLine => {
        if (dLine.addons) {
          dLine.addons.forEach(aLine => {
            const foundInArray2 = tempSApps?.findIndex(
              tLine => tLine.code === aLine.code,
            )
            if (foundInArray2 >= 0) tempSApps.splice(foundInArray2, 1)
          })
        }
      })

      // GEP-6803: BNI is read-only display (provisioned in Salesforce, never
      // managed by OOE). Strip before persisting to ordercapture/createOrder
      // so it never lands in the order_line table.
      const tempSAppsNoBNI = tempSApps.filter(
        ({code}) => !SOCIAL_ADS_BNI_PLAN_CODES.includes(code),
      )
      const tempDAppsNoBNI = tempDApps.filter(
        ({code}) => !SOCIAL_ADS_BNI_PLAN_CODES.includes(code),
      )
      selectedApps.push(
        ...getAllSelectedDefaultLines('app', tempSAppsNoBNI, tempDAppsNoBNI),
      )
    }
    if ((sCentersAndApps.oneTimes, dCentersAndApps.oneTimes)) {
      selectedOneTimes.push(
        ...getAllSelectedDefaultLines(
          'oneTime',
          sCentersAndApps.oneTimes,
          dCentersAndApps.oneTimes,
        ),
      )
    }
    const selectedCenterLines = []
    let line_counter = 1
    if (selectedCenters) {
      for (let center of selectedCenters) {
        // let pUPrice =
        //   center.unitAmount || center.unitAmount === 0
        //     ? center.unitAmount
        //     : center.amount || center.amount === 0
        //     ? center.amount
        //     : null
        // if (pUPrice) {
        //   pUPrice = pUPrice * (center.quantity ? center.quantity : 1)
        // }
        selectedCenterLines.push({
          line_number: line_counter,
          parent_line_number: null,
          plansv5_id: center.id,
          action_code: center.tempLineActionCode,
          order_line_status: 'InProgress',
          saas_product_category: 'Center',
          saas_product_type: 'main',
          saas_product_code: center.code,
          saas_instance_id: null,
          recurly_subscription_id: center.uuid ? center.uuid : null,
          total_cost: getSassProductPriceAndUamount('uPrice', center),
          unit_cost: getSassProductPriceAndUamount('uAmount', center),
          // saas_product_price: getSassProductPriceAndUamount('uPrice', center),
          // saas_product_unit_amount: getSassProductPriceAndUamount(
          //   'uAmount',
          //   center,
          // ),
          quantity: getSassProductQuantity(center),
          // quantity: center.quantity,
          // one_time_fee: null,
          start_date: new Date(),
          end_date: null,
        })
        let p_lc = line_counter
        line_counter = line_counter + 1

        if (center.entitlements) {
          for (let entitlement of center.entitlements) {
            // if (!entitlement.isRequired) {
            const cUAmount =
              entitlement.unitAmount || entitlement.unitAmount === 0
                ? entitlement.unitAmount
                : entitlement.amount || entitlement.amount === 0
                ? entitlement.amount
                : 0
            let cUPrice = cUAmount
            if (cUAmount) {
              cUPrice =
                cUAmount * (entitlement.quantity ? entitlement.quantity : 1)
            }
            selectedCenterLines.push({
              line_number: line_counter,
              parent_line_number: p_lc,
              plansv5_id: entitlement.id,
              action_code: entitlement.tempLineActionCode
                ? entitlement.tempLineActionCode
                : center.tempLineActionCode,
              order_line_status: 'InProgress',
              saas_product_category: 'Center',
              saas_product_type: 'entitlement',
              saas_product_code: entitlement.code,
              saas_instance_id: null,
              recurly_subscription_id: entitlement.uuid
                ? entitlement.uuid
                : entitlement.subscriptionId
                ? entitlement.subscriptionId
                : null,
              total_cost: cUPrice,
              unit_cost: cUAmount,
              // saas_product_price: cUPrice,
              // saas_product_unit_amount: cUAmount,
              quantity: entitlement.quantity ? entitlement.quantity : 1,
              // one_time_fee: null,
              start_date: new Date(),
              end_date: null,
            })
            line_counter = line_counter + 1
            // }
          }
        }
      }
    }
    const selectedAppLines = []
    if (selectedApps) {
      for (let app of selectedApps) {
        const pUAmount =
          app.unitAmount || app.unitAmount === 0
            ? app.unitAmount
            : app.amount || app.amount === 0
            ? app.amount
            : null
        let pUPrice = pUAmount
        if (pUAmount) {
          if (app.code === 'seobase-5-thryv-m2m') {
            pUPrice = pUAmount * (app.amount || app.quantity || 1)
          } else {
            pUPrice = pUAmount * (app.quantity ? app.quantity : 1)
          }
        }
        selectedAppLines.push({
          line_number: line_counter,
          parent_line_number: null,
          plansv5_id: app.id,
          action_code: app.tempLineActionCode,
          order_line_status: 'InProgress',
          saas_product_category: 'App',
          saas_product_type: 'addon',
          saas_product_code: app.code,
          saas_instance_id: null,
          recurly_subscription_id: app.uuid
            ? app.uuid
            : app.subscriptionId
            ? app.subscriptionId
            : null,
          total_cost: pUPrice,
          unit_cost: pUAmount,
          // saas_product_price: pUPrice,
          // saas_product_unit_amount: pUAmount,
          quantity:
            app.code === 'seobase-5-thryv-m2m'
              ? app.amount || app.quantity || 1
              : app.quantity
              ? app.quantity
              : 1,
          // one_time_fee: null,
          start_date: new Date(),
          end_date: null,
        })
        let p_lc = line_counter
        line_counter = line_counter + 1
        if (app.addons) {
          for (let addon of app.addons) {
            const cUAmount =
              addon.unitAmount || addon.unitAmount === 0
                ? addon.unitAmount
                : addon.amount || addon.amount === 0
                ? addon.amount
                : null
            let cUPrice = cUAmount
            if (cUAmount) {
              cUPrice = cUAmount * (addon.quantity ? addon.quantity : 1)
            }
            selectedAppLines.push({
              line_number: line_counter,
              parent_line_number: p_lc,
              plansv5_id: addon.id,
              action_code: addon.tempLineActionCode
                ? addon.tempLineActionCode
                : app.tempLineActionCode,
              order_line_status: 'InProgress',
              saas_product_category: 'App',
              saas_product_type: 'addon',
              saas_product_code: addon.code,
              saas_instance_id: null,
              recurly_subscription_id: addon.uuid
                ? addon.uuid
                : addon.subscriptionId
                ? addon.subscriptionId
                : null,
              total_cost: cUPrice,
              unit_cost: cUAmount,
              // saas_product_price: cUPrice,
              // saas_product_unit_amount: cUAmount,
              quantity: addon.quantity ? addon.quantity : 1,
              // one_time_fee: null,
              start_date: new Date(),
              end_date: null,
            })
            line_counter = line_counter + 1
          }
        }
      }
    }
    // Back-fill parent_line_number for apps that are stored flat in
    // selectedCentersAndApps.apps but logically belong under a parent
    // (appmarket sub-apps via .addons nesting, or SEO add-ons via requiresAddon).
    // Build a map: childCode → parentCode from all5PlanPrices catalog data.
    const childToParent = {}
    const allCatalogItems = [
      ...(all5PlanPrices?.centers || []),
      ...(all5PlanPrices?.apps || []),
    ]
    allCatalogItems.forEach(item => {
      if (item.requiresAddon && item.requiresAddon.length > 0) {
        childToParent[item.code] = item.requiresAddon[0]
      } else if (item.parentProduct) {
        childToParent[item.code] = item.parentProduct
      }
    })
    // Also include any apps nested under appmarket via .addons in the existing subs
    dCentersAndApps?.apps?.forEach(app => {
      if (app.addons) {
        app.addons.forEach(addon => {
          if (!childToParent[addon.code]) {
            childToParent[addon.code] = app.code
          }
        })
      }
    })
    // Build a lookup: productCode → line_number from all lines built so far
    const allBuiltLines = [...selectedCenterLines, ...selectedAppLines]
    const codeToLineNumber = {}
    allBuiltLines.forEach(l => {
      if (l.saas_product_code)
        codeToLineNumber[l.saas_product_code] = l.line_number
    })
    // Apply parent_line_number to any app line that is missing it
    selectedAppLines.forEach(l => {
      if (l.parent_line_number === null && childToParent[l.saas_product_code]) {
        const parentCode = childToParent[l.saas_product_code]
        if (codeToLineNumber[parentCode] !== undefined) {
          l.parent_line_number = codeToLineNumber[parentCode]
        }
      }
    })
    // const uniqueSelectedAppLines = selectedAppLines.reduce((acc, obj) => {
    //   if (!acc.some(o => o.saas_product_code === obj.saas_product_code)) {
    //     acc.push(obj)
    //   }
    //   return acc
    // }, [])
    const selectedOneTimeLines = []
    if (selectedOneTimes) {
      for (let oneTime of selectedOneTimes) {
        const pUAmount =
          oneTime.unitAmount || oneTime.unitAmount === 0
            ? oneTime.unitAmount
            : oneTime.amount || oneTime.amount === 0
            ? oneTime.amount
            : null
        let pUPrice = pUAmount
        if (pUAmount) {
          pUPrice = pUAmount * (oneTime.quantity ? oneTime.quantity : 1)
        }
        selectedOneTimeLines.push({
          line_number: line_counter,
          parent_line_number: null,
          plansv5_id: oneTime.id,
          action_code: oneTime.tempLineActionCode,
          order_line_status: 'InProgress',
          saas_product_category: 'OneTimeFee',
          saas_product_type: 'oneTimeFee',
          saas_product_code: oneTime.code,
          saas_instance_id: null,
          recurly_subscription_id: oneTime.uuid
            ? oneTime.uuid
            : oneTime.subscriptionId
            ? oneTime.subscriptionId
            : null,
          total_cost: pUPrice,
          unit_cost: pUAmount,
          // saas_product_price: pUPrice,
          // saas_product_unit_amount: pUAmount,
          quantity: oneTime.quantity ? oneTime.quantity : 1,
          // one_time_fee: null,
          start_date: new Date(),
          end_date: null,
        })
        let p_lc = line_counter
        line_counter = line_counter + 1
        if (oneTime.entitlements) {
          for (let entitlement of oneTime.entitlements) {
            const cUAmount =
              entitlement.unitAmount || entitlement.unitAmount === 0
                ? entitlement.unitAmount
                : entitlement.amount || entitlement.amount === 0
                ? entitlement.amount
                : null
            let cUPrice = cUAmount
            if (cUAmount) {
              cUPrice =
                cUAmount * (entitlement.quantity ? entitlement.quantity : 1)
            }
            selectedOneTimeLines.push({
              line_number: line_counter,
              parent_line_number: p_lc,
              plansv5_id: entitlement.id,
              action_code: entitlement.tempLineActionCode
                ? entitlement.tempLineActionCode
                : oneTime.tempLineActionCode,
              order_line_status: 'InProgress',
              saas_product_category: 'OneTimeFee',
              saas_product_type: 'entitlement',
              saas_product_code: entitlement.code,
              saas_instance_id: null,
              recurly_subscirption_id: entitlement.uuid
                ? entitlement.uuid
                : entitlement.subscriptionId
                ? entitlement.subscriptionId
                : null,
              total_cost: cUPrice,
              unit_cost: cUAmount,
              // saas_product_price: cUPrice,
              // saas_product_unit_amount: cUAmount,
              quantity: entitlement.quantity ? entitlement.quantity : 1,
              // one_time_fee: null,
              start_date: new Date(),
              end_date: null,
            })
            line_counter = line_counter + 1
          }
        }
      }
    }
    console.log('selectedCenterLines', selectedCenterLines)
    console.log('selectedAppLines', selectedAppLines)
    // console.log('uniqueSelectedAppLines', uniqueSelectedAppLines)
    console.log('selectedOneTimeLines', selectedOneTimeLines)

    orderLines.push(
      ...selectedCenterLines,
      ...selectedAppLines,
      // ...uniqueSelectedAppLines,
      ...selectedOneTimeLines,
    )
    console.log('orderLines', orderLines)
    return orderLines
  }

  const getAllSelectedDefaultLines = (prodCat, lines1, lines2) => {
    const sLines = [...lines1]
    const dLines = [...lines2]
    // const tempOrderLines = []
    const selectedandDefaultlines = []
    // const defaultLines = []

    dLines?.forEach(dLine => {
      let found = false
      sLines?.forEach(sLine => {
        if (dLine.code === sLine.code) {
          dLine.tempLineActionCode = 'Update'
          found = true
        }
      })
      if (!found) {
        dLine.tempLineActionCode = 'Cancel'
      }
      selectedandDefaultlines.push(dLine)
    })

    sLines?.forEach(sLine => {
      const foundInArray2 = dLines?.find(dLine => dLine.code === sLine.code)
      sLine.tempLineActionCode = foundInArray2 ? 'Update' : 'New'
      if (!foundInArray2) selectedandDefaultlines.push(sLine)
    })

    console.log(
      'selectedandDefaultlines - updated action code - ' + prodCat,
      selectedandDefaultlines,
    )
    // console.log('defaultLines - ' + prodCat, defaultLines)

    // tempOrderLines.push(...selectedlines, ...defaultLines)
    // console.log('tempOrderLines - ' + prodCat, tempOrderLines)

    return selectedandDefaultlines
  }

  const saveBillingAddress = data => {
    let saveData = {
      ...accountInfo,
      recurlyFirst: data.firstName,
      recurlyLast: data.lastName,
      recurlyCompany: data.company,
      salesRepCode: data.salesRepCode,
      salesRepInfo: data.salesRepInfo,
      behalfEmail: data.behalfEmail,
      behalfFirst: data.behalfFirst,
      behalfLast: data.behalfLast,
      xpCode: data.xpCode,
      overrideRepInfo: data.overrideRepInfo,
      overrideRepCode: data.overrideRepCode,
      overrideRepEmail: data.overrideRepEmail,
      overrideRepFirst: data.overrideRepFirst,
      overrideRepLast: data.overrideRepLast,
      abn: data.abn,
      billingAddress: {
        ...accountInfo.billingAddress,
        street1: data.street1,
        city: data.city,
        state: data.region,
        zipCode: data.postalCode,
        phone: data.phone,
        mobile: data.mobile,
      },
      keapAccount: data?.keapAccount,
      keapID: data?.keapID,
    }
    if (!isAus && !isNZ) {
      delete saveData.abn
    }
    if (!data.salesRepCode) {
      delete saveData.salesRepInfo
      delete saveData.salesRepCode
      delete saveData.behalfEmail
      delete saveData.behalfFirst
      delete saveData.behalfLast
    }
    if (!data.xpCode) {
      delete saveData.xpCode
    }
    if (!data.overrideRepCode) {
      delete saveData.overrideRepInfo
      delete saveData.overrideRepCode
      delete saveData.overrideRepEmail
      delete saveData.overrideRepFirst
      delete saveData.overrideRepLast
    }
    setAccountInfo(saveData)
    setOrderData5CU({
      ...orderData5CU,
      accountInfo: {...orderData5CU.accountInfo, ...saveData},
    })
    setKeapAccount(saveData?.keapAccount ?? null)
    setKeapID(saveData?.keapID ?? null)
  }

  const renderNextAction = () => {
    if (isUpgrade && !isAddressUpdated) {
      return (
        <>
          {windowWidth > 1260 && (
            <CancelOrderModal cancelUrl="/accounts/my-accounts" />
          )}
          <UpdateAddressModal
            nextStep={saveBillingAddress}
            selectedCountry={selectedCountry}
            accountInfo={accountInfo}
            is5Order={true}
            setIsAddressUpdated={setIsAddressUpdated}
            hasKeapAccountAbility={hasKeapAccountAbility}
            setHasKeapAccountAbility={setHasKeapAccountAbility}
            keapAccount={keapAccount}
            setKeapAccount={setKeapAccount}
            keapID={keapID}
            setKeapID={setKeapID}
            handleStartOver={handleStartOver}
          />
        </>
      )
    }
    if (isUpgrade && isAddressUpdated && !isBillingNoticeDisplayed) {
      return (
        <>
          {windowWidth > 1260 && (
            <CancelOrderModal cancelUrl="/accounts/my-accounts" />
          )}
          <BillingNoticeModal
            setIsBillingNoticeDisplayed={setIsBillingNoticeDisplayed}
          />
        </>
      )
    }
    if (isUpgrade && isAddressUpdated && isBillingNoticeDisplayed) {
      handleContinue()
      return null
    }
    return (
      <>
        {windowWidth > 1425 && (
          <CancelOrderModal
            cancelUrl={isFromAccountSetup ? '/accounts/my-accounts' : '/orders'}
          />
        )}
        {isLoading ? (
          <Spinner />
        ) : (
          <Button variant="primary" onClick={handleContinue}>
            Continue
          </Button>
        )}
      </>
    )
  }
  // if (
  //   (selectedCountry === 'CA' ||
  //     selectedCountry === 'AU' ||
  //     selectedCountry === 'NZ' ||
  //     selectedCountry === 'US') &&
  //   !DEFAULT_CART_ITEMS.some(center => center.name === 'Reporting Center')
  // ) {
  //   DEFAULT_CART_ITEMS.push({
  //     name: 'Reporting Center',
  //     img: reportingCenterIcon,
  //   })
  // } else if (
  //   selectedCountry !== 'US' &&
  //   selectedCountry !== 'AU' &&
  //   selectedCountry !== 'NZ' &&
  //   selectedCountry !== 'CA'
  // ) {
  //   const index = DEFAULT_CART_ITEMS.findIndex(
  //     center => center.name === 'Reporting Center',
  //   )
  //   if (index !== -1) {
  //     // DEFAULT_CART_ITEMS.splice(index, 1)
  //     console.log('DEFAULT_CART_ITEMS : ', DEFAULT_CART_ITEMS)
  //   }
  // }

  const cartItems = isPartnerOpsUser
    ? [
        {name: 'My Account', img: commandCenterIconV1},
        {name: 'Marketing Center', img: marketingCenterIconv1},
        {name: 'Keap Max', img: keapMaxIcon},
        {name: 'KCP Partner Certification', img: keapMaxIcon},
        {name: 'KCC Partner Certification', img: keapMaxIcon},
      ]
    : [...DEFAULT_CART_ITEMS]

  if (selectedCountry === 'US') {
    cartItems.push({
      name: 'Workforce Center',
      img: workforceCenterIconv1,
    })
  }

  if (!isPartnerOpsUser) {
    cartItems.push({
      name: 'My Account',
      img: commandCenterIconV1,
    })
  }

  const filteredCartItems = cartItems.filter(
    item =>
      !(selectedCountry === 'KY' || selectedCountry === 'BB') ||
      (item.name !== 'Marketing Center' && item.name !== 'Thryv'),
  )

  const rankItem = item => {
    if (
      item.code === 'seobase-5-thryv-m2m' ||
      item.code === 'tl-mc-5-thryv-m2m' ||
      item.code === 'tl-tax-5-thryv-m2m'
    )
      return 1
    if (item.code === 'appmarket-5-thryv-m2m') return 2
    if (item?.groupTitle === 'Thryv Add-Ons') return 3
    if (
      item.code === 'addon-5-keap-addons' ||
      item.code === 'addon-5-keap-addons-annual' ||
      item.code === 'addon-5-keap-addons-legacy-annual' ||
      item.code === 'addon-5-keap-addons-legacy-m2m'
    )
      return 4
    if (item?.groupTitle === 'Keap Add-Ons') return 5
    return 6
  }

  const itemComparator = (a, b) => {
    const rankA = rankItem(a)
    const rankB = rankItem(b)
    return rankA - rankB
  }

  let selectedApps
  let appsInCenters = selectedCentersAndApps?.centers?.filter(({name}) =>
    APPS_IN_CENTERS.includes(name),
  )
  if (appsInCenters && appsInCenters.length > 0) {
    selectedApps = [...appsInCenters]
  }

  let selApps = selectedCentersAndApps?.apps
  if (selApps && selApps.length > 0) {
    if (selectedApps && selectedApps.length > 0) {
      selectedApps = [...selectedApps, ...selApps]
    } else {
      selectedApps = [...selApps]
    }
  }

  const sortedApps = selectedApps?.sort(itemComparator)

  console.log('sortedApps :: ', sortedApps)

  const findSoftwareCenterContent = softwareName => {
    if (softwareName === 'Keap Max') {
      const isKeapFamilyItem = ({code, name, groupTitle}) =>
        KEAP_FAMILY_CODES.includes(code) ||
        (code?.toLowerCase()?.includes('keap_') &&
          code != 'keap_kcp-cert-5-fee-annual' &&
          code != 'keap_kcc-cert-5-fee-annual') ||
        name?.toLowerCase().includes('keap') ||
        groupTitle?.toLowerCase().includes('keap')

      const keapFamilyItems = [
        ...(selectedCentersAndApps?.centers?.filter(isKeapFamilyItem) || []),
      ]

      return (
        keapFamilyItems.find(({alreadyIncluded}) => !alreadyIncluded) ||
        keapFamilyItems?.[0]
      )
    }

    if (softwareName === 'KCP Partner Certification') {
      return selectedCentersAndApps?.centers.find(
        ({code}) => code === 'keap_kcp-cert-5-fee-annual',
      )
    }

    if (softwareName === 'KCC Partner Certification') {
      return selectedCentersAndApps?.centers.find(
        ({code}) => code === 'keap_kcc-cert-5-fee-annual',
      )
    }

    if (softwareName === 'Thryv') {
      return selectedCentersAndApps?.centers.find(
        ({groupTitle}) => groupTitle === 'Thryv',
      )
    }

    return (
      selectedCentersAndApps?.centers.find(({name}) =>
        name?.toLowerCase().includes(softwareName.toLowerCase()),
      ) ||
      selectedCentersAndApps?.centers.find(({groupTitle}) =>
        groupTitle?.toLowerCase().includes(softwareName.toLowerCase()),
      ) ||
      selectedCentersAndApps?.apps.find(({name}) =>
        name?.toLowerCase().includes(softwareName.toLowerCase()),
      ) ||
      selectedCentersAndApps?.apps.find(({groupTitle}) =>
        groupTitle?.toLowerCase().includes(softwareName.toLowerCase()),
      )
    )
  }

  const findSoftwareContentType = content => {
    if (!content?.code) return 'Center'
    const isApp = selectedCentersAndApps?.apps?.some(
      ({code}) => code === content.code,
    )
    return isApp ? 'App' : 'Center'
  }

  return (
    <CatalogSectionContainer
      className="h-100 w-100"
      style={{
        backgroundColor: '#F4F6FB',
        padding: '17px 20px 0 20px',
        borderRadius: '15px',
        position: 'relative',
        height: '800px',
      }}
    >
      <div>
        <div className="d-flex justify-content-between">
          <Header variant="h4" fontWeight="semibold">
            Your Order
          </Header>
          <StartOverButtonWithModal
            parentProps={{variant: 'primary', text: 'Start Over'}}
            modalProps={{
              title: 'Are you sure you want to \nstart over?',
              subtitle: 'If you start over, your changes will not be saved',
              handleAction: handleStartOver,
            }}
          />
        </div>
      </div>
      <div style={{height: '570px', overflowY: 'auto'}}>
        <div style={{paddingRight: '20px'}}>
          <div style={{paddingTop: '21px'}}>
            <ParagraphText className="font-weight-bold" variant="lg">
              Software
            </ParagraphText>
            {filteredCartItems.map(({name, img}) => {
              const content = findSoftwareCenterContent(name)
              const prodType = findSoftwareContentType(content)
              const title =
                name === 'Keap Max' && content?.name ? content.name : name

              return (
                <CartItem
                  key={name}
                  title={title}
                  img={img}
                  content={content}
                  isCenter={true}
                  isCanAusNz={isCanAusNz}
                  handleRemoveItem={handleRemoveItem}
                  prodType={prodType}
                  defaultCentersAndApps={defaultCentersAndApps}
                  selectedCountry={selectedCountry}
                />
              )
            })}
          </div>
          <div style={{paddingTop: '21px'}}>
            <ParagraphText className="font-weight-bold" variant="lg">
              Add-Ons
            </ParagraphText>
            {selectedCentersAndApps?.apps.length > 0 ||
            selectedCentersAndApps?.oneTimes.length > 0 ||
            isTLInCart ? (
              <>
                {sortedApps && sortedApps?.length > 0 && (
                  <RenderItems
                    items={sortedApps}
                    isNewTLMCAccessible={isNewTLMCAccessible}
                    selectedCentersAndApps={selectedCentersAndApps}
                    handleRemoveItem={handleRemoveItem}
                    prodType={'App'}
                    defaultCentersAndApps={defaultCentersAndApps}
                    selectedCountry={selectedCountry}
                  />
                )}
                {/* {selectedCentersAndApps?.centers && (
                  <RenderItems
                    items={selectedCentersAndApps.centers}
                    filterFunc={({name}) => APPS_IN_CENTERS.includes(name)}
                    isCenter
                    isNewTLMCAccessible={isNewTLMCAccessible}
                  />
                )}
                {selectedCentersAndApps?.apps && (
                  <RenderItems
                    items={selectedCentersAndApps.apps.sort((a, b) => {
                      const rankItem = item => {
                        if (item.code === 'appmarket-5-thryv-m2m') return 1
                        if (
                          item?.groupTitle === 'Thryv Add-Ons' ||
                          item.code === 'addon-5-keap-addons'
                        )
                          return 2
                        if (item?.groupTitle === 'Keap Add-Ons') return 4
                        return 5
                      }
                      const rankA = rankItem(a)
                      const rankB = rankItem(b)
                      return rankA - rankB
                    })}
                    selectedCentersAndApps={selectedCentersAndApps}
                    isNewTLMCAccessible={isNewTLMCAccessible}
                  />
                )} */}
              </>
            ) : (
              <p style={{color: '#A3A5A7', fontSize: '14px'}}>None Selected</p>
            )}
          </div>
          <div style={{paddingTop: '21px'}}>
            {selectedCentersAndApps?.oneTimes?.length > 0 && (
              <>
                <ParagraphText className="font-weight-bold" variant="lg">
                  One Time Fees
                </ParagraphText>
                <RenderItems
                  items={selectedCentersAndApps.oneTimes.sort((a, b) =>
                    a.name.includes('Fee')
                      ? 1
                      : b.name.includes('Fee')
                      ? -1
                      : 0,
                  )}
                  isNewTLMCAccessible={isNewTLMCAccessible}
                  handleRemoveItem={handleRemoveItem}
                  prodType={'OneTimeFee'}
                  defaultCentersAndApps={defaultCentersAndApps}
                  selectedCountry={selectedCountry}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-between"
        style={{
          height: '35px',
          marginTop: '15px',
          borderTop: 'solid 2px #dee2e6',
        }}
      >
        <ParagraphText variant="lg" className="mt-2">
          {' '}
          <strong>Total</strong>
        </ParagraphText>
        <ParagraphText variant="lg" className="mt-2">
          <strong>{formatPrice(totalPrice, 1, '', selectedCountry)}*</strong>
        </ParagraphText>
      </div>
      <div className="d-flex justify-content-between">
        <ParagraphText variant="sm"> </ParagraphText>
        <ParagraphText variant="sm" style={{opacity: '50%'}}>
          *
          {isAus
            ? 'excludes incentives'
            : isNZ
            ? 'excludes fees and incentives'
            : 'excludes taxes, fees, and incentives'}
        </ParagraphText>
      </div>
      <div className="bottom-container">
        {isAus && (
          <p>
            {upgradePaymentPreview
              ? '*All Plans include GST'
              : '*All Plans include GST except SEO'}
          </p>
        )}
        <div className="buttons-container">
          <div className="d-flex">
            <CouponButtonWithModal
              modalProps={{
                code,
                setCode,
                selectedCountry,
                selectedCentersAndApps,
                accountInfo,
                order,
              }}
            />
          </div>
          <PlanDiscountsButtonWithModal
            modalProps={{
              selectedCountry,
              selectedCentersAndApps,
              defaultCentersAndApps,
              expiredCentersAndApps,
              clientGroup,
              accountInfo,
              order,
            }}
          />
          <div className="d-flex">{renderNextAction()}</div>
        </div>
      </div>
      {showAccountFailedModal && (
        <AccountFailedModalComponent
          errorMessage={accountFailedErrorMessage}
          onClose={() => {
            setShowAccountFailedModal(false)
            setAccountFailedErrorMessage(null)
          }}
        />
      )}
    </CatalogSectionContainer>
  )
}

export {OrderSummary}
